import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, Send, Menu, X } from 'lucide-react';
import './InfoPage.css';

const ContactPage: React.FC = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="info-page">
      <motion.nav initial={{ y: -100 }} animate={{ y: 0 }} className="info-nav">
        <div className="nav-container">
          <div className="nav-logo" onClick={() => navigate('/')}>
            <img src="/homequest-logo.svg" alt="HomeQuest Tech" className="logo-image" />
            <div className="logo-tagline">Where Land Meets Logic</div>
          </div>
          <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <a onClick={() => navigate('/')}>Home</a>
            <a onClick={() => navigate('/features')}>Features</a>
            <a onClick={() => navigate('/pricing')}>Pricing</a>
            <button onClick={() => navigate('/login')} className="nav-login">Sign In</button>
            <button onClick={() => navigate('/pricing')} className="nav-cta">Start Free Trial</button>
          </div>
          <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </motion.nav>

      <section className="info-hero">
        <div className="hero-container">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="hero-badge">
              <Mail className="badge-icon" />
              <span>GET IN TOUCH</span>
            </div>
            <h1 className="hero-title">
              Contact <span className="gradient-text">Our Team</span>
            </h1>
            <p className="hero-subtitle">
              Have questions about HomeQuest? We're here to help you transform your construction projects with AI.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="info-content">
        <div className="content-container">
          <h2>Get Started Today</h2>
          <p>
            Ready to join our exclusive beta program? We're currently accepting 10 founding members who want to revolutionize their construction management workflow.
          </p>

          <h3 style={{ marginTop: '3rem' }}>Contact Information</h3>
          <p style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Mail style={{ width: '24px', height: '24px', color: '#3B82F6' }} />
            <strong>Email:</strong> <a href="mailto:support@homequesttech.com">support@homequesttech.com</a>
          </p>
          <p style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Phone style={{ width: '24px', height: '24px', color: '#3B82F6' }} />
            <strong>Phone:</strong> Coming Soon
          </p>
          <p style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <MapPin style={{ width: '24px', height: '24px', color: '#3B82F6' }} />
            <strong>Location:</strong> Atlanta, GA
          </p>

          <h3 style={{ marginTop: '3rem' }}>Quick Links</h3>
          <p>
            <a onClick={() => navigate('/pricing')} style={{ cursor: 'pointer' }}>View Pricing & Join Beta</a> - Lock in 30% off for life
          </p>
          <p>
            <a onClick={() => navigate('/features')} style={{ cursor: 'pointer' }}>Explore Features</a> - See what makes HomeQuest different
          </p>
          <p>
            <a onClick={() => navigate('/help')} style={{ cursor: 'pointer' }}>Help Center</a> - Find answers to common questions
          </p>

          <button onClick={() => navigate('/pricing')} className="cta-button">
            Join Beta Program <Send style={{ width: '20px', height: '20px' }} />
          </button>
        </div>
      </section>

      <footer className="info-footer">
        <div className="footer-container">
          <div className="footer-content">
            <p>&copy; 2025 HomeQuest Tech™. All rights reserved.</p>
            <div className="footer-links">
              <a onClick={() => navigate('/')}>Home</a>
              <a onClick={() => navigate('/about')}>About</a>
              <a onClick={() => navigate('/privacy')}>Privacy</a>
              <a onClick={() => navigate('/terms')}>Terms</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
